import { react } from "react";
import Introduction from "../components/Introduction";
import HeroSection from "../components/HeroSection";
import Seo from "../components/Seo";

const About = () => {
    return (
        <div className="newspaper-container-wrapper">
            <Seo
                title="About Us"
                description="Etawah Times के बारे में जानें - Etawah, Uttar Pradesh का विश्वसनीय स्थानीय समाचार पत्र और ई-पेपर।"
                canonical="/about"
            />
            <HeroSection pageType="other" />
            <Introduction />
        </div>
    );

};

export default About;
